"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.HRParser = void 0;
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
class HRParser {
    /**
     * Parses the passed-in HRToken to HTML.
     * @param src - HRToken to parse.
     * @returns - HTML representation of the passed-in HRToken.
     */
    parse(src) {
        return '<hr class="hr" />';
    }
}
exports.HRParser = HRParser;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaHIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcGFyc2Vycy9oci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsK0JBQStCOzs7QUFLL0I7O0dBRUc7QUFDSCxNQUFhLFFBQVE7SUFDbkI7Ozs7T0FJRztJQUNJLEtBQUssQ0FBRSxHQUFZO1FBQ3hCLE9BQU8sbUJBQW1CLENBQUE7SUFDNUIsQ0FBQztDQUNGO0FBVEQsNEJBU0MiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBDb3B5cmlnaHQgwqkgMjAyMSBNb3ZlIENsb3NlclxuXG5pbXBvcnQgeyBQYXJzZXNUb2tlblRvSFRNTCB9IGZyb20gJy4uL2NvbnRyYWN0cy9wYXJzZXInXG5pbXBvcnQgeyBIUlRva2VuIH0gZnJvbSAnLi4vY29udHJhY3RzL3Rva2VuaXplcidcblxuLyoqXG4gKiBAYXV0aG9yIFN0YW5pc8WCYXcgR3JlZ29yIDxzdGFuaXNsYXcuZ3JlZ29yQG1vdmVjbG9zZXIucGw+XG4gKi9cbmV4cG9ydCBjbGFzcyBIUlBhcnNlciBpbXBsZW1lbnRzIFBhcnNlc1Rva2VuVG9IVE1MPEhSVG9rZW4+IHtcbiAgLyoqXG4gICAqIFBhcnNlcyB0aGUgcGFzc2VkLWluIEhSVG9rZW4gdG8gSFRNTC5cbiAgICogQHBhcmFtIHNyYyAtIEhSVG9rZW4gdG8gcGFyc2UuXG4gICAqIEByZXR1cm5zIC0gSFRNTCByZXByZXNlbnRhdGlvbiBvZiB0aGUgcGFzc2VkLWluIEhSVG9rZW4uXG4gICAqL1xuICBwdWJsaWMgcGFyc2UgKHNyYzogSFJUb2tlbik6IHN0cmluZyB7XG4gICAgcmV0dXJuICc8aHIgY2xhc3M9XCJoclwiIC8+J1xuICB9XG59XG4iXX0=